import axios from "axios";
import {getAppLang, getProperty, getUserToken} from "../../../../utils";
import {
    WEB_TEMPLATE_LIST,
    WEB_TEMPLATE_UPDATE,
} from "../../../../constants/api.constants";
import {webTemplateConstants} from "../../../../constants/Web/webTemplate.constants";

export function getWebTemplateList() {

    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        },
    };

    return dispatch => {
        dispatch({
            type: 'WEB_TEMPLATE_LIST',
            payload: axios.get(WEB_TEMPLATE_LIST, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

export function updateWebTemplate(params) {

    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        },
        body: {
            params: {
                property_id: getProperty(),
                template_id: params.template_id,
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'WEB_TEMPLATE_UPDATE',
            payload: axios.post(WEB_TEMPLATE_UPDATE, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

export function clearWebTemplate() {
    return dispatch => {
        dispatch({
            type: webTemplateConstants.WEB_TEMPLATE_CLEAR,
        })
    }
}
